@if (notifications.length) {
  @for (notification of notifications; track notification) {
    <div class="notification"
      [ngClass]="[notification.type, (notification?.config?.textAlign || '')]"
      >
      <div class="icon">
        <img class="pl-1"
          src="assets/images/icons/exclamation-1.svg">
        </div>
        <div class="messages-container w-100">
          @if (notification?.content?.violations?.length) {
            <div
              class="d-inline-block pl-3 pr-1 w-100">
            <button type="button"
              class="close"
              (click)="clear()"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            @for (violation of notification?.content?.violations; track violation) {
              <div>
                {{ violation.message }}
              </div>
            }
          </div>
        }
        @if (!notification?.content?.violations?.length) {
          <div
            class="d-inline-block pl-3 pr-1 w-100">
            <button type="button"
              class="close"
              (click)="clear()"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            {{ notification.content?.clientMessage || notification.content }}
          </div>
        }
      </div>
    </div>
  }
}

